export * from '@primeuix/themes/lara/panel';
export { default } from '@primeuix/themes/lara/panel';
